import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";

export const displayWeekdayDigitMonthAndDay = (
  date: string,
  isMobile?: boolean
) =>
  date
    ? new Intl.DateTimeFormat("fa-IR", {
        weekday: isMobile ? "narrow" : "short",
        month: "2-digit",
        day: "2-digit"
      })
        .format(new Date(date))
        .split(" ")
        .join(" - ")
    : "--:--";

export const formatPrice = (price: number) =>
  price > 0
    ? numberConvert(
        price >= 10_000
          ? numberSeparator(Number((price / 10).toFixed(0)) / 1000)
          : Number((price / 10).toFixed(0)) / 1000,
        {
          locale: "fa"
        }
      )
    : "ناموجود";
